import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin: 0;\n  overflow: hidden;\n  border: none;\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { LINE_GRAY, SENSATION_WHITE } from '../colors';
import { withOmitProps } from '../helpers';
import { zIndexKeys, zIndexMixin } from '../mixins/layout';
import { TABS_CONTAINER_HEIGHT } from './constants';
import { height } from '../style';
export default styled.div.withConfig(withOmitProps(['height', 'fixedHeight'].concat(zIndexKeys)))(_templateObject(), LINE_GRAY, SENSATION_WHITE, function (_ref) {
  var _ref$height = _ref.height,
      value = _ref$height === void 0 ? TABS_CONTAINER_HEIGHT : _ref$height,
      _ref$fixedHeight = _ref.fixedHeight,
      fixedHeight = _ref$fixedHeight === void 0 ? false : _ref$fixedHeight;
  return fixedHeight ? height(value) : '';
}, zIndexMixin);